import { render, staticRenderFns } from "./purchase-order-list.vue?vue&type=template&id=ab3e35c6&"
import script from "./purchase-order-list.vue?vue&type=script&lang=ts&"
export * from "./purchase-order-list.vue?vue&type=script&lang=ts&"
import style0 from "./purchase-order-list.vue?vue&type=style&index=0&id=ab3e35c6&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports